
class SmsPlugin {
  enable = () => {
    // TO BE IMPLEMENTED
  };
}

export default new SmsPlugin();
